<template>
  <div class="chart" v-if="show">
    <apexchart :width="1200" :height="100" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    colors: {
      default() {
        return [
          '#002146',
          '#002146',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
          '#30C2F9',
        ]
      },
    },
    date: {
      default() {
        return moment().format('YYYY-MM-DD')
      },
    },
    series: {
      default() {
        return []
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.show = true

      // const date = moment(1640228341000).format('YYYY-MM-DD')

      // console.log(this.series)
    })
  },
  data() {
    return {
      show: false,
      chartOptions: {
        colors: this.colors,
        legend: {
          show: false,
          onItemClick: {
            toggleDataSeries: false,
          },
          onItemHover: {
            highlightDataSeries: false,
          },
          //showForSingleSeries: true,
          //customLegendItems: items,
          markers: {
            //fillColors: ['#00E396', '#ff9900']
          },
        },
        chart: {
          type: 'rangeBar',
          toolbar: {
            show: false,
          },
          animations: {
            enabled: false,
          },
          selection: {
            enabled: false,
          },
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            rangeBarGroupRows: true,
            barHeight: '80',
          },
        },
        tooltip: {
          x: {
            format: 'HH:mm',
          },
          y: {
            formatter: function(val, opt) {
              const goals = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex].goals
              if (goals && goals.length) {
                return `[${goals[0].name}]1`
              }
              return val
            },
          },
        },
        xaxis: {
          type: 'datetime',
          min: new Date(this.date + ' 08:00').getTime(),
          max: new Date(this.date + ' 22:01').getTime(),
          labels: {
            show: true,
            datetimeUTC: false,
            style: {
              colors: ['#fff'],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              //fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
            },
          },
          axisTicks: {
            show: true,
          },
        },
        yaxis: {
          show: false,
        },
      },
    }
  },
}
</script>

<style lang="less" scoped>
.chart {
  color: #666;
}
</style>
